var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bar-main" }, [
    !_vm.positionCheck("multiplexing") && !_vm.positionCheck("email-task")
      ? _c("div", [
          _vm.isEdit
            ? _c("span", { attrs: { title: _vm.$t("panel.edit") } }, [
                _c("i", {
                  staticClass: "icon iconfont icon-edit",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.edit($event)
                    },
                  },
                }),
              ])
            : _vm._e(),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.detailsShow,
                  expression: "detailsShow",
                },
              ],
              attrs: { title: _vm.$t("panel.details") },
            },
            [
              _c("i", {
                staticClass: "icon iconfont icon-chakan",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.showViewDetails("details")
                  },
                },
              }),
            ]
          ),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.enlargeShow,
                  expression: "enlargeShow",
                },
              ],
              attrs: { title: _vm.$t("panel.enlarge") },
            },
            [
              _c("i", {
                staticClass: "icon iconfont icon-fangda",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.showViewDetails("enlarge")
                  },
                },
              }),
            ]
          ),
        ])
      : _vm._e(),
    _vm.positionCheck("multiplexing")
      ? _c(
          "div",
          {
            staticStyle: {
              "margin-right": "-1px",
              width: "18px",
              "z-index": "5",
            },
          },
          [
            _c("el-checkbox", {
              attrs: { size: "medium" },
              on: { change: _vm.multiplexingCheck },
              model: {
                value: _vm.multiplexingCheckModel,
                callback: function ($$v) {
                  _vm.multiplexingCheckModel = $$v
                },
                expression: "multiplexingCheckModel",
              },
            }),
          ],
          1
        )
      : _vm._e(),
    _vm.positionCheck("email-task") && _vm.element.component === "user-view"
      ? _c(
          "div",
          {
            staticStyle: {
              "margin-right": "-1px",
              width: "18px",
              "z-index": "5",
            },
          },
          [
            _c("el-checkbox", {
              attrs: { size: "medium" },
              on: { change: _vm.emailTaskCheck },
              model: {
                value: _vm.isTaskChecked,
                callback: function ($$v) {
                  _vm.isTaskChecked = $$v
                },
                expression: "isTaskChecked",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }